import { combineReducers } from 'redux';

import showSearchBarOnMobile from './show-search-bar-on-mobile';
import showSearchModal from './show-search-modal';
import categoryName from './category-name-reducer';
import keyword from './keyword-reducer';
import location from './location-reducer';
import userInteraction from './user-interaction';
import g5SParams from './g5s-params';
import searchCategoryReducer from './search-category-reducer';

export default combineReducers({
    showSearchBarOnMobile,
    showSearchModal,
    categoryName,
    keyword,
    location,
    userInteraction,
    g5SParams,
    searchCategoryReducer
});
